import React from 'react';
import { useTypedTranslation } from '@app/hooks';
import { returnToLogin } from '../helpers';
import { PasslyButton } from '@app/components';
import { SetLoginForm } from '@app/models';
import Icon from '@app/components/Icon/index';
interface IProps {
    setLoginForm?: SetLoginForm;
}

export const Reset2faTokenSuccess: React.SFC<IProps> = ({ setLoginForm }) => {
    const { translation } = useTypedTranslation();

    return (
        <div className='reset-password'>
            <div className='reset-password__success-icon-block'>
                <Icon icon='successIco' className='reset-password__success-icon' />
            </div>
            <h1>{translation('RESET_COMPLETE')}</h1>
            <p className='reset-password__success-2fa-text'>{translation('RESET_SMS_COMPLETE_MESSAGE')}</p>
            <div className='reset-password__buttons'>
                <PasslyButton className='reset-password__button-success' color='primary' variant='contained' onClick={returnToLogin(setLoginForm)}>
                    {translation('PROCEED_TO_SIGNIN')}
                </PasslyButton>
            </div>
        </div>
    );
};
